module.exports = __webpack_public_path__ + "37c3fb4a510b6ed306859b7f529c9a3a.png";